export const LOGGED_IN_CATEGORY_PAGE_PAGE_SIZE = 36;

export const LOGGED_IN_FULL_WIDTH_CATEGORY_PAGE_PAGE_SIZE = 40;

export const LOGGED_IN_VISUAL_NAV_UPGRADE_CATEGORY_PAGE_PAGE_SIZE = 40;

export const LOGGED_IN_FULL_WIDTH_VISUAL_NAV_UPGRADE_CATEGORY_PAGE_PAGE_SIZE = 60;
